module.exports = __webpack_public_path__ + "static/c_large-a7e5b26bb97f67de2139a2da8689be6e.jpg";